/*
  Panel lateral del índice, solo en móvil.

  En escritorio los enlaces ya están en línea y el CSS esconde el botón, el
  panel y el fondo. Este fichero no comprueba el ancho: si nadie puede pulsar el
  botón, nada de esto llega a ejecutarse.

  Por qué no es un <dialog> nativo: showModal() bloquea el scroll de la página
  entera y anima mal cuando el panel entra desde el lado. Con el atributo hidden
  y una clase se controlan las dos cosas y sigue siendo accesible.
*/
(function () {
  'use strict';

  var boton = document.querySelector('[data-lander-nav-abrir]');
  var panel = document.querySelector('[data-lander-nav-panel]');
  var fondo = document.querySelector('[data-lander-nav-fondo]');
  if (!boton || !panel || !fondo) return;

  var FOCUSABLES = 'a[href], button:not([disabled])';
  var abierto = false;

  function enfocables() {
    return Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLES));
  }

  function abrir() {
    if (abierto) return;
    abierto = true;
    panel.hidden = false;
    fondo.hidden = false;
    // Un fotograma entre quitar hidden y poner la clase: sin él, display pasa
    // de none a flex en el mismo tick y el navegador no anima la transición.
    requestAnimationFrame(function () {
      panel.classList.add('is-abierto');
      fondo.classList.add('is-abierto');
    });
    boton.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    var primero = enfocables()[0];
    if (primero) primero.focus();
  }

  function cerrar(devolverFoco) {
    if (!abierto) return;
    abierto = false;
    panel.classList.remove('is-abierto');
    fondo.classList.remove('is-abierto');
    boton.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';

    // hidden se pone al terminar la animación, o el panel desaparecería de
    // golpe en vez de deslizarse. Si no hay animación, transitionend no llega.
    var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (sinMovimiento) {
      panel.hidden = true;
      fondo.hidden = true;
    } else {
      panel.addEventListener('transitionend', function ocultar() {
        panel.removeEventListener('transitionend', ocultar);
        if (!abierto) {
          panel.hidden = true;
          fondo.hidden = true;
        }
      });
    }

    if (devolverFoco) boton.focus();
  }

  boton.addEventListener('click', abrir);
  fondo.addEventListener('click', function () {
    cerrar(true);
  });

  document.addEventListener('click', function (evento) {
    if (evento.target.closest('[data-lander-nav-cerrar]')) {
      cerrar(true);
      return;
    }
    // Un enlace del panel salta a una sección de esta misma página: si el panel
    // se queda abierto, tapa justo lo que el visitante ha ido a ver.
    if (abierto && evento.target.closest('.lander-nav__panel a[href^="#"]')) {
      cerrar(false);
    }
  });

  document.addEventListener('keydown', function (evento) {
    if (!abierto) return;

    if (evento.key === 'Escape') {
      cerrar(true);
      return;
    }

    // El foco no puede escaparse a la página de detrás, que está tapada.
    if (evento.key !== 'Tab') return;
    var lista = enfocables();
    if (!lista.length) return;
    var primero = lista[0];
    var ultimo = lista[lista.length - 1];
    if (evento.shiftKey && document.activeElement === primero) {
      evento.preventDefault();
      ultimo.focus();
    } else if (!evento.shiftKey && document.activeElement === ultimo) {
      evento.preventDefault();
      primero.focus();
    }
  });

  // Al pasar a escritorio el panel deja de existir para el CSS. Si se quedara
  // marcado como abierto, el scroll del documento seguiria bloqueado.
  window.matchMedia('(min-width: 850px)').addEventListener('change', function (e) {
    if (e.matches) cerrar(false);
  });
})();
